import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

export const props = ({ query, params }: { query: {}; params: {}}) => ({ ...query, ...params })

const routes: Array<RouteConfig> = [
  {
    path: '/',
    meta: {
      auth: false
    },
    props,
    redirect: '/approvals'
  },
  {
    path: '/approvals',
    props,
    component: () => import('../views/approvals/Index.vue')
  },
  {
    path: '/approvals/:id',
    props,
    component: () => import('../views/approvals/Detail.vue')
  },
  {
    path: '/oauth',
    meta: {
      auth: false
    },
    props,
    component: () => import('../views/OAuth.vue')
  },
  {
    path: '*',
    meta: {
      auth: false
    },
    component: {
      render (h) {
        return h('div', '404')
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
